exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-single{padding-top:50px;padding-bottom:50px;max-width:420px;margin:auto}.Form .Form-Field{padding-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/theme/components/Attachments/Form.scss
// module id = 750
// module chunks = 0